import PageHero from '../components/sections/PageHero';
import ProcessTimeline from '../components/sections/ProcessTimeline';
import FaqSection from '../components/sections/FaqSection';
import CtaBanner from '../components/sections/CtaBanner';
import Container from '../components/ui/Container';
import SectionHeading from '../components/ui/SectionHeading';
import Reveal from '../components/ui/Reveal';
import Icon from '../components/ui/Icon';
import { deliverableDocs, slaCommitments } from '../data/process';

export default function Process() {
  return (
    <>
      <PageHero
        eyebrow="Recycling process"
        title="A workflow you can hand to your auditor"
        description="Every stage has a defined owner, a stated turnaround and a document that proves it happened. Nothing runs on trust alone."
      >
        <dl className="mt-10 grid max-w-3xl gap-4 sm:grid-cols-3">
          {slaCommitments.map((sla) => (
            <div key={sla.label} className="rounded-xl border border-white/10 bg-white/5 px-4 py-4">
              <dt className="text-[0.68rem] font-medium uppercase tracking-wider text-ink-500">
                {sla.label}
              </dt>
              <dd className="mt-1.5 font-display text-base font-bold text-white">{sla.value}</dd>
            </div>
          ))}
        </dl>
      </PageHero>

      <ProcessTimeline />

      {/* Documentation grid */}
      <section className="section bg-surface">
        <Container>
          <SectionHeading
            eyebrow="What you receive"
            title="Eight documents, issued as standard"
            description="No compliance document is billed as an extra. If a regulator or auditor can ask for it, it is already in your file."
          />

          <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {deliverableDocs.map((doc, index) => (
              <Reveal key={doc.name} delay={index * 0.05}>
                <div className="group h-full rounded-xl2 border border-ink-100 bg-white p-6 transition-all duration-300 ease-smooth hover:-translate-y-1.5 hover:border-brand-200 hover:shadow-lift">
                  <span className="grid h-11 w-11 place-items-center rounded-xl bg-brand-50 text-brand-700 transition-all duration-300 group-hover:bg-brand-600 group-hover:text-white">
                    <Icon name={doc.icon} className="h-5 w-5" />
                  </span>
                  <h3 className="mt-5 font-display text-base font-semibold text-ink-900">{doc.name}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-ink-500">{doc.description}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </Container>
      </section>

      <FaqSection />
      <CtaBanner />
    </>
  );
}
